define(['basemodel'], (BaseModel) => BaseModel.extend({
    isStatusActive () {
        return this.get('status') === 'ACTIVE';
    },
    isStatusBlocked () {
        return this.get('status') === 'BLOCKED';
    },
    isStatusChanged () {
        return this.get('status') === 'CHANGED';
    }
}));
